import { render, staticRenderFns } from "./ViewHelp.vue?vue&type=template&id=e46fac36&scoped=true"
import script from "./ViewHelp.vue?vue&type=script&lang=js"
export * from "./ViewHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46fac36",
  null
  
)

export default component.exports